import { Vector3 } from 'three';

import { NavMeshQuery } from '@recast-navigation/core';

export const getClosestPointOnNavMesh = (
  position: Vector3,
  target: Vector3,
  navMeshQuery?: NavMeshQuery
) => {
  const result = navMeshQuery?.findClosestPoint(position, {
    halfExtents: { x: 50, y: 50, z: 50 },
  });

  if (result?.success) {
    target.copy(result.point);
    return true;
  }

  target.copy(position);
  return false;
};
